class UpsellSlider extends HTMLElement {
  constructor() {
    super();
    this.sliderRef = this.querySelector("[data-slider]");
    this.nextRef = this.querySelector('[data-navigation="next"]') || null;
    this.previousRef = this.querySelector('[data-navigation="prev"]') || null;
    this.paginationRef = this.querySelector("[data-pagination]") || null;
    this.initSlider = this.initSlider.bind(this);
    this.autoPlay = false;
    this.spaceBetween = 10;
    this.loop = false;
  }

  connectedCallback() {
    this.initSlider();
  }

  initSlider() {
    this.swiper = new Swiper(this.sliderRef, {
      // Optional parameters
      loop: this.loop,
      spaceBetween: this.spaceBetween,
      autoplay: this.autoPlay || false,
      grabCursor: true,

      keyboard: {
        enabled: true,
      },

      // If we need pagination
      pagination: {
        el: this.paginationRef,
        clickable: true,
      },

      // Navigation arrows
      navigation: {
        nextEl: this.nextRef,
        prevEl: this.previousRef,
      },
    });
  }

  disconnectedCallback() {
    this.swiper.destroy();
  }
}
customElements.define("upsell-slider", UpsellSlider);

class AnnouncementBarSlider extends UpsellSlider {
  constructor() {
    super();
    this.autoPlay = {
      delay: 2000,
    };
    this.spaceBetween = 0;
  }
}
customElements.define("announcement-bar-slider", AnnouncementBarSlider);

const swiper_be = new Swiper('.slider-be', {
  slidesPerView: 1.5,
  pagination: {
    el: '.slick-slider-dots-be',
    type: 'bullets',
    clickable: true
  },
  navigation: {
    nextEl: document.querySelector(".next-be"),
    prevEl: document.querySelector(".prev-be"),
  },
  autoPlay: false,
  breakpoints: {
    568: {
      slidesPerView: 3,
    },
    1025: {
      slidesPerView: 4
    },
    1299: {
      slidesPerView: 6
    }
  }
});

const slider_fr = new Swiper('.slider-fr', {
  slidesPerView: 1.5,
  pagination: {
    el: '.slick-slider-dots-be',
    type: 'bullets',
    clickable: true
  },
  navigation: {
    nextEl: document.querySelector(".next-be"),
    prevEl: document.querySelector(".prev-be")
  },
  autoPlay: false,
  breakpoints: {
    568: {
      slidesPerView: 3,
    },
    1025: {
      slidesPerView: 4
    },
    1299: {
      slidesPerView: 6
    }
  }
});


class ProductCardsSlider extends HTMLElement {
  constructor() {
    super();
    this.sliderRef = this.querySelector("[data-slider]");
    this.nextRef = this.querySelector('[data-navigation="next"]') || null;
    this.previousRef = this.querySelector('[data-navigation="prev"]') || null;
    this.paginationRef = this.querySelector("[data-pagination]") || null;
    this.initSlider = this.initSlider.bind(this);
    this.productsToShow = this.dataset.productsToShow;
    this.productToShowMobile = (this.productsToShow === "3") ? 1 : 1.1;      
    this.autoPlay = false;
    this.spaceBetween = 8;
  }

  connectedCallback() {
    this.initSlider();
  }

  initSlider() {
    this.swiper = new Swiper(this.sliderRef, {
      // Optional parameters
      loop: false,
      spaceBetween: this.spaceBetween,
      autoplay: this.autoPlay || false,
      slidesPerView: this.productToShowMobile,

      keyboard: {
        enabled: true,
      },

      // If we need pagination
      pagination: {
        el: this.paginationRef,
        clickable: true,
      },

      // Navigation arrows
      navigation: {
        nextEl: this.nextRef,
        prevEl: this.previousRef,
      },

      // Breakpoints
      breakpoints: {
        992: {
          slidesPerView: this.productsToShow || 4,
          slidesPerGroup: 4,
        },
      },
    });
  }

  disconnectedCallback() {
    this.swiper.destroy();
  }
}
customElements.define("product-cards-slider", ProductCardsSlider);
